module.exports = __webpack_public_path__ + "img/grasstex.56e39cf.png";